/* eslint-disable import/no-unresolved */

import React, { useState, memo } from 'react'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import Chip from '@material-ui/core/Chip'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import InputBase from '@material-ui/core/InputBase'
import Paper from '@material-ui/core/Paper'
import SaveIcon from '@material-ui/icons/Save'
import CancelIcon from '@material-ui/icons/Cancel'
import {
  permitsList,
  minPermisos,
  generalTitles,
} from 'src/constants/index'
import PolygonsTable from 'src/components/sharedComponents/Tablas/index'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import PoperComponent from 'src/components/sharedComponents/Popover'
import Card from 'src/components/sharedComponents/Card/Card'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import Search from 'src/components/sharedComponents/SearchInput'
import canUseState from 'src/utils/canUseState'
import useInputValue from '@auteco/utils/hooks/useInputValue'
import { useStyles } from './styles'

const TerritotiosPage = (props) => {
  const {
    territorios = [],
    zona = [],
    search,
    select,
    permisos,
    searchTerritory,
    onCreateTerritory,
    territorioszonas,
    handleSearchTerritory,
    handleDeleteZyT,
    handleCreate,
    handleSearch,
    handleDelete,
    handleSelect,
    handleUpdate,
  } = props

  const classes = useStyles()
  const inputValue = useInputValue('')
  const inputEdit = useInputValue('')
  const [edit, setEdit] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const create = open ? 'simple-popover' : undefined

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(!anchorEl)
  }

  const onCreate = (event) => {
    event.preventDefault()
    setAnchorEl(null)
    onCreateTerritory({
      value: inputValue.value,
    })
  }

  const onUpdate = (event) => {
    event.preventDefault()
    console.log('zona territorios',select)
    setAnchorEl(null)
    setEdit(!edit)
    handleUpdate({
      territorio: inputEdit.value,
      id: select?.id,
      unidad_negocio_id: territorioszonas[0]?.unidad_negocio_id,
    })
  }

  const columnsPolygonsTerritory = [
    { title: 'Color', field: 'color' },
    { title: 'Territorio', field: 'territorio' },
    { title: 'T_id', field: 'territorio_id', hidden: true },
    { title: 'Zona', field: 'zona' },
    { title: 'Z_id', field: 'zona_id', hidden: true },
    { title: 'id_Negocio', field: 'unidad_negocio_id', hidden: true },
  ]
  return (
    <>
      <CardTitle
        title={generalTitles.TITLE_TERRITORY}
        subTitle={generalTitles.SUB_TITLE_CARD}
      />
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Card>
            <CardHeader>
              <Grid container>
                <Grid item xs={12} sm={5}>
                  <h3>{generalTitles.TERRITORY}</h3>
                  <p>Seleccione un territorio</p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Tooltip title={generalTitles.ADD} aria-label="add">
                    <Fab
                      onClick={handleOpenPopover}
                      size="medium"
                      color="primary"
                      aria-label="add"
                    >
                      <AddIcon />
                    </Fab>
                  </Tooltip>
                  <PoperComponent
                    handleUpdate={onCreate}
                    handleClose={handleClose}
                    inputValue={inputValue}
                    className={classes.popover}
                    anchorEl={anchorEl}
                    title={generalTitles.NEW}
                    open={open}
                    id={create}
                  />
                </Grid>
              </Grid>
              <Search
                handleSearch={handleSearchTerritory}
                search={searchTerritory}
              />
            </CardHeader>
            <CardBody className={classes.cardBody}>
              {territorios.map((item) => (
                <div key={item.id}>
                  <Chip
                    id={item.id}
                    label={item.territorio.toUpperCase()}
                    clickable
                    className={classes.chip}
                    color="primary"
                    deleteIcon={
                      <DeleteIcon
                        className={classes.tableActionButtonIcon}
                        style={{ color: '#f44336 ' }}
                      />
                    }
                    variant="outlined"
                    onDelete={
                      permisos[permitsList.ADMIN_TERRITORIOS] >=
                      minPermisos.ELIMINAR
                        ? handleDelete(item)
                        : null
                    }
                    onClick={
                      permisos[permitsList.ADMIN_TERRITORIOS] >=
                      minPermisos.CREAR
                        ? handleSelect(item)
                        : null
                    }
                  />
                </div>
              ))}
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Grid container>
                <Grid item sm={6}>
                  <h3>{generalTitles.TITLE_ZONES}</h3>
                </Grid>
                <Grid item sm={6}>
                  {select && (
                    <>
                      <p>{generalTitles.TERRITORY} seleccionado</p>
                      <Chip
                        avatar={<Avatar>T</Avatar>}
                        label={`${select.territorio}`.toUpperCase()}
                        clickable
                        className={classes.chip}
                        color="primary"
                        deleteIcon={
                          <EditIcon
                            className={classes.tableActionButtonIcon}
                            style={{ color: ' #4CAF50' }}
                          />
                        }
                        variant="outlined"
                        style={{ width: '100%' }}
                        onClick={() => setEdit(!edit)}
                        onDelete={
                          permisos[permitsList.ADMIN_TERRITORIOS] >=
                          minPermisos.ACTUALIZAR
                            ? () => setEdit(!edit)
                            : null
                        }
                      />
                      {edit && (
                        <Paper
                          component="form"
                          onSubmit={onUpdate}
                          className={classes.paper}
                        >
                          <InputBase
                            className={classes.input}
                            placeholder={select.territorio}
                            inputProps={{
                              'aria-label': `${select.territorio}`,
                            }}
                            {...inputEdit}
                          />
                          <IconButton
                            type="submit"
                            className={classes.iconButton}
                            aria-label="search"
                          >
                            <SaveIcon />
                          </IconButton>
                          <IconButton
                            type="onClick"
                            onClick={() => setEdit(!edit)}
                            className={classes.iconButton}
                            aria-label="search"
                          >
                            <CancelIcon />
                          </IconButton>
                        </Paper>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
              <Search handleSearch={handleSearch} search={search} />
            </CardHeader>
            <CardBody className={classes.cardBody}>
              {zona.map((item) => {
                const canUse = canUseState(
                  territorioszonas,
                  item,
                  'zona_id',
                  'id',
                )
                return (
                  <div key={item.id}>
                    <Chip
                      avatar={
                        <Avatar
                          className={classes.avatar}
                          style={{
                            backgroundColor: `${item.color}`,
                            color: '#fff',
                          }}
                        >
                          {item.zona.charAt(0)}
                        </Avatar>
                      }
                      label={item.zona.toUpperCase()}
                      clickable
                      className={classes.chip}
                      color={!canUse ? 'default' : 'primary'}
                      onClick={handleCreate({
                        ...item,
                        territorio_id: select.id,
                      })}
                      disabled={!select}
                    />
                  </div>
                )
              })}
            </CardBody>
          </Card>
        </Grid>
      </div>
      {/*= =======================================================================
        Tabla Territorios
        ======================================================================== */}
      <PolygonsTable
        columns={columnsPolygonsTerritory}
        dataTable={territorioszonas}
        idPermisoTabla={permitsList.ADMIN_GERENTES_JEFES}
        onDeleteTable={handleDeleteZyT}
        titleTable={generalTitles.TITLE_TABLE_TERRITORY}
        hiddenEdit
        hiddenDelete={false}
      />
    </>
  )
}

export default memo(TerritotiosPage)
